import { analyticsClient } from '../common/analyticsClient';
import type { AnalyticsEventRequest } from './utils/types';

class AnalyticsAPIClient {
  public async trackEvent(payload: AnalyticsEventRequest): Promise<void> {
    if (!payload.uniqueId) {
      payload.uniqueId = createAnalyticsEventId();
    }
    await analyticsClient.post('/a/event', payload);
  }
}

export const analyticsAPIClient = new AnalyticsAPIClient();

function createAnalyticsEventId(): string {
  const randomUUID = globalThis.crypto?.randomUUID;
  if (typeof randomUUID === 'function') {
    return randomUUID.call(globalThis.crypto);
  }
  return `evt_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}
